import { TFilterGroupModel } from './ui-filter.types';
import { UiFilterTasks } from './ui-filter.tasks';

export const UiFilterPipeline = {
  computeFilterModel: <T>(filterGroup: TFilterGroupModel<T>): TFilterGroupModel<T> => {
    return [
      UiFilterTasks.selectedFilters,
      UiFilterTasks.evaluateHasSelected,
      UiFilterTasks.fillSelectedValues,
      UiFilterTasks.evaluateIsValid,
      UiFilterTasks.logFilterModel,
    ].reduce((acc, v) => v(acc), filterGroup);
  },
};
